"use client";

// The pale-yellow choice box of the order popups (a real <select>, so it works with keyboard and screen readers).
// centeredChevron: draws the small arrow itself, in the middle of the field's height (a native select puts it at the edge).
export default function SelectField({ label, value, onChange, options, centeredChevron = false }) {
  return (
    <label className="relative block">
      <span className="sr-only">{label}</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`h-[48px] w-full rounded-[6px] bg-[#F3F2E6] px-4 text-[16px] text-[#6D778E] shadow-custom-dark-to-white focus:outline-none ${centeredChevron ? "appearance-none pr-10" : ""}`}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {centeredChevron ?
        <svg viewBox="0 0 12 8" width="12" height="8" aria-hidden="true" className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-[#6D778E]">
          <path d="M1 1.5l5 5 5-5" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      : null}
    </label>
  );
}
